<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <path class="filled" d="M53.609,51.015H10.391a5.653,5.653,0,0,1-5.646-5.646V18.631a5.653,5.653,0,0,1,5.646-5.646H53.609a5.653,5.653,0,0,1,5.646,5.646V45.369A5.653,5.653,0,0,1,53.609,51.015ZM10.391,16.985a1.648,1.648,0,0,0-1.646,1.646V45.369a1.648,1.648,0,0,0,1.646,1.646H53.609a1.648,1.648,0,0,0,1.646-1.646V18.631a1.648,1.648,0,0,0-1.646-1.646Z" fill="#035ce0"/>
      <g>
        <rect class="filled" x="39.889" y="24.778" width="7.364" height="4" rx="1" fill="#035ce0"/>
        <rect class="filled" x="16.747" y="24.778" width="17.768" height="4" rx="1" fill="#035ce0"/>
        <rect class="filled" x="36.383" y="35.677" width="10.69" height="4" rx="1" fill="#035ce0"/>
      </g>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
